import styled from "styled-components";

export const MainStyles = styled.div``;
